import { ChackImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetTestimonials =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.testimonials.get;

      const response = await PostFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const SearchClients =
  ({ callback, search }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.clients.search;

      const data = {
        search,
      };

      const response = await PostFunction({
        data,
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });

      callback(response);
    } catch (err) {
      callback(false);
    }
  };
export const GetClients =
  ({ callback, page, rowsPerPage }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.clients.get;

      const data = {
        page,
        rowsPerPage,
      };

      const response = await PostFunction({
        data,
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      console.log({ responsedcasdgadsg: response });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageClients =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      if (editMode) {
        bodyFormData.append("id", values?.id);
      }

      if (CheckDataIfExit(values?.first_name)) {
        bodyFormData.append("first_name", values?.first_name?.trim());
      } else {
        bodyFormData.append("first_name", "");
      }
      if (CheckDataIfExit(values?.last_name)) {
        bodyFormData.append("last_name", values?.last_name?.trim());
      } else {
        bodyFormData.append("last_name", "");
      }
      if (CheckDataIfExit(values?.email)) {
        bodyFormData.append("email", values?.email?.trim());
      } else {
        bodyFormData.append("email", "");
      }
      if (CheckDataIfExit(values?.password)) {
        bodyFormData.append("password", values?.password?.trim());
      } else {
        bodyFormData.append("password", "");
      }

      if (
        values?.image &&
        values?.image != null &&
        values?.image != undefined &&
        ChackImageIsFile({ data: values?.image, IsBoolean: true })
      ) {
        bodyFormData.append("image", values?.image);
      } else if (editMode && !values?.image) {
        bodyFormData.append("image", "");
      }

      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode ? UrlApi.clients.edit : UrlApi.clients.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditClients =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          id: id,
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.clients.edit,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteClients =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data = {
        idsclients: id,
      };
      const response = await PostFunction({
        data,
        Route: UrlApi.clients.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
